module.exports = __webpack_public_path__ + "img/ldgh.271a5a82.png";